import aT from '../const/action-type'
import initial from '../store/initial'

export default (state = initial.showAdminPanel, action) => {
  switch (action.type) {
    case aT.SHOW_ADMIN_PANEL:
      return action.data
    case aT.RESET_STORE:
      return initial.showAdminPanel
    default:
      return state
  }
}
